/**
 * Align Product Card Titles and Prices
 * Automatically adjusts product title heights to align prices across rows
 */

function alignProductCardTitles() {
  // Find all product card containers
  const productRows = document.querySelectorAll('[data-collection-products], .row[data-collection-products]');
  
  if (productRows.length === 0) return;
  
  productRows.forEach(function(row) {
    // Get all product cards in this row
    const productCards = row.querySelectorAll('.product-card-detail');
    
    if (productCards.length === 0) return;
    
    // Group cards by rows (based on their vertical position)
    const cardsByRow = [];
    let currentRow = [];
    let lastTop = -1;
    
    // Reset any previous height adjustments
    productCards.forEach(function(card) {
      const title = card.querySelector('.product-title');
      if (title) {
        title.style.minHeight = '';
        title.style.height = '';
      }
    });
    
    // Group cards into rows based on their Y position
    productCards.forEach(function(card) {
      const rect = card.getBoundingClientRect();
      const top = Math.round(rect.top);
      
      if (lastTop === -1 || Math.abs(top - lastTop) < 10) {
        // Same row (within 10px tolerance)
        currentRow.push(card);
        lastTop = top;
      } else {
        // New row
        if (currentRow.length > 0) {
          cardsByRow.push(currentRow);
        }
        currentRow = [card];
        lastTop = top;
      }
    });
    
    // Don't forget the last row
    if (currentRow.length > 0) {
      cardsByRow.push(currentRow);
    }
    
    // For each row, find the tallest title and apply that height to all titles
    cardsByRow.forEach(function(cardsInRow) {
      let maxHeight = 0;
      
      // Find the tallest title in this row
      cardsInRow.forEach(function(card) {
        const title = card.querySelector('.product-title');
        if (title) {
          const height = title.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        }
      });
      
      // Apply the max height to all titles in this row
      if (maxHeight > 0) {
        cardsInRow.forEach(function(card) {
          const title = card.querySelector('.product-title');
          if (title) {
            title.style.minHeight = maxHeight + 'px';
          }
        });
      }
    });
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', function() {
  alignProductCardTitles();
});

// Run after images load (in case they affect layout)
window.addEventListener('load', function() {
  alignProductCardTitles();
});

// Run when window is resized
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    alignProductCardTitles();
  }, 250);
});

// Run when collection filters are applied (if using AJAX)
if (typeof document.addEventListener !== 'undefined') {
  document.addEventListener('click', function(e) {
    // Listen for filter/sort changes
    if (e.target.closest('.facet-checkbox, .facet-filters__sort, [data-collection-filter]')) {
      setTimeout(function() {
        alignProductCardTitles();
      }, 500);
    }
  });
}

// Export for manual calls if needed
if (typeof window !== 'undefined') {
  window.alignProductCardTitles = alignProductCardTitles;
}

